import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { logEvent } from '../../analytics';
import toast from 'react-hot-toast';
import { generatePDFFromRef } from '../../utils/generatePDF';

const DownloadPDFButton = ({ pdfRef, eventCategory, disabled }) => {
  const { t } = useTranslation();
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    // Add print stylesheet
    const style = document.createElement('style');
    style.id = 'pdf-print-styles';
    style.textContent = `
      @media print {
        body {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
        * {
          -webkit-font-smoothing: antialiased !important;
          -moz-osx-font-smoothing: grayscale !important;
          text-rendering: optimizeLegibility !important;
        }
      }
    `;
    document.head.appendChild(style);

    return () => {
      const styleElement = document.getElementById('pdf-print-styles');
      if (styleElement) {
        styleElement.remove();
      }
    };
  }, []);

  const handleDownloadPDF = async () => {
    logEvent(eventCategory, 'PDF');
    setIsDownloading(true);

    try {
      const now = new Date();
      const formattedDate = now.toISOString().slice(0, 10);
      const formattedTime = now.toTimeString().slice(0, 5).replace(':', '-');
      const filename = `document_${formattedDate}_${formattedTime}.pdf`;

      await generatePDFFromRef(pdfRef, {
        filename,
        method: 'save',
        resolution: 3
      });
      
      toast.success(t('download_pdf.success'));
    } catch (error) {
      console.error('PDF generation error:', error);
      toast.error(t('download_pdf.error'));
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Button
      icon={<DownloadOutlined />}
      onClick={handleDownloadPDF}
      disabled={isDownloading || disabled}
    >
      {t('download_pdf.label')}
    </Button>
  );
};

export default DownloadPDFButton;
